import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Cached across the app so we don't spam the endpoint
let cachedUrl = null;
let cachePromise = null;

export const fetchDefaultAvatarUrl = async () => {
  if (cachedUrl) return cachedUrl;
  if (cachePromise) return cachePromise;
  cachePromise = axios.get(`${API}/settings/default-avatar`)
    .then(res => {
      const url = res.data.url;
      // Convert relative URL (from our storage) to absolute
      cachedUrl = url?.startsWith('http') ? url : `${BACKEND_URL}${url}`;
      return cachedUrl;
    })
    .catch(() => {
      cachedUrl = 'https://images.unsplash.com/photo-1650702970095-f5b8ebeebce5?w=400';
      return cachedUrl;
    })
    .finally(() => { cachePromise = null; });
  return cachePromise;
};

export const invalidateDefaultAvatarCache = () => {
  cachedUrl = null;
  cachePromise = null;
};

export const useDefaultAvatar = () => {
  const [url, setUrl] = useState(cachedUrl);
  useEffect(() => {
    if (!cachedUrl) {
      fetchDefaultAvatarUrl().then(setUrl);
    }
  }, []);
  return url;
};

/**
 * Returns the correct image URL for a user: their primary photo if any,
 * otherwise the system default avatar.
 */
export const getUserPhotoUrl = (user, defaultUrl) => {
  if (!user) return defaultUrl;
  const photos = user.photos || [];
  const idx = user.primary_photo_index ?? 0;
  return photos[idx] || photos[0] || defaultUrl;
};
